export const createHash = async (alg: string, seed: string) => {
    const encoder = new TextEncoder()
    const buffer = encoder.encode(seed)
    const hashBuffer = await crypto.subtle.digest(alg, buffer)
    const hash = Array.from(new Uint8Array(hashBuffer), (byte) => byte.toString(16).padStart(2, '0')).join("")
    return hash
}
